import log from "loglevel";
import { apiCoreEndpoint } from "settings";
import * as t from "./types";
import { processServiceResponse } from "lib/request";

export const verifyJwtService = async () => {
  log.info("Verifying integrity of JWT in Local Storage...");
  const VERIFY_API_ENDPOINT = `${apiCoreEndpoint}/auth/verify`;
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  try {
    const response = await fetch(VERIFY_API_ENDPOINT, parameters);
    let json;
    if (response.ok) {
      json = await response.json();
    } else if (response.status === 401) {
      json = {
        error: {
          success: false,
          message: "Unauthorized",
        },
      };
    } else {
      json = {
        error: {
          success: false,
          message: "Unable to process request",
        },
      };
    }
    return json;
  } catch (error) {
    log.error(error);
    return {
      success: false,
      message: "Unable to connect to database",
    };
  }
};

export const decodeJwtService = (request?: t.DecodeJwtRequestType) => {
  const DECODE_JWT_ENDPOINT = `${apiCoreEndpoint}/auth/decode/`;
  log.info("Decoding JWT in local storage...");
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(DECODE_JWT_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, DECODE_JWT_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const refreshJwtService = (request?: t.RefreshJwtRequestType) => {
  const REFRESH_JWT_ENDPOINT = `${apiCoreEndpoint}/auth/refresh/`;
  log.info("Refreshing JWT in local storage...");
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(REFRESH_JWT_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, REFRESH_JWT_ENDPOINT);
    })
    .then((json) => {
      const data = json.data;
      if (data) {
        if (data.token) {
          log.info("Setting key/value in storage...");
          localStorage.setItem("user_session", data.token);
        }
      }
      return json;
    })
    .catch((error) => {
      log.error(`JWT Refresh failed! Reason: ${error}`);
      return {
        error: {
          message: "Unable to process request",
        },
      };
    });
};
